import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { downloadCertificate } from '../../utils/certificate';

const NAME_KEY = 'dn_cert_name';

interface Props { themeName: string; scoreLabel: string; accent: string; variant?: 'gold' | 'primary'; }

// Anonieme certificaat-download: vraagt om je naam en maakt direct een PDF.
export const CertificateButton: React.FC<Props> = ({ themeName, scoreLabel, accent, variant = 'gold' }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(() => { try { return localStorage.getItem(NAME_KEY) || ''; } catch { return ''; } });

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const clean = name.trim();
    if (!clean) return;
    try { localStorage.setItem(NAME_KEY, clean); } catch { /* negeer */ }
    downloadCertificate({ name: clean, themeName, scoreLabel, accent });
    setOpen(false);
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} className={variant === 'gold' ? 'btn-gold' : 'btn-primary'}>
        <Download className="w-4 h-4" strokeWidth={1.75} /> Download certificaat
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-2 w-full max-w-sm">
      <label className="text-sm text-sub">Op welke naam mag het certificaat?</label>
      <div className="flex gap-2">
        <input autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder="Je volledige naam" className="field flex-1" />
        <button type="submit" disabled={!name.trim()} className={variant === 'gold' ? 'btn-gold' : 'btn-primary'}>Download</button>
      </div>
    </form>
  );
};
